import { Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

type AnalyticCardEmptyStateProps = {
  icon: ReactNode;
  title: string;
  description: string;
};

export const AnalyticCardEmptyState: FC<AnalyticCardEmptyStateProps> = ({ icon, title, description }) => {
  return (
    <Stack
      sx={{
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 0.5
      }}>
      {icon}
      <Typography variant="body2" sx={{
        fontWeight: 600
      }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          maxWidth: "207px",
          color: "#7E8796"
        }}>
        {description}
      </Typography>
    </Stack>
  );
};
